import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledExpandSVG = styled.svg<IconProps>`
  & .cls-1 {
    fill: #32363a;
  }

  & .cls-2 {
    fill: var(--du-color-grey-pale, #f8f8f8);
    stroke: var(--du-color-grey-pale, #f8f8f8);
  }

  &.disabled {
    .cls-2 {
      fill: var(--du-color-grey, #969696);
      stroke: var(--du-color-grey, #969696);
    }
  }

  &:hover,
  &.active {
    &:not([disabled]) {
      .cls-1 {
        fill: none;
      }

      .cls-2 {
        fill: var(--du-color-primary, #128370);
        stroke: var(--du-color-primary, #128370);
      }

      .cls-3,
      .cls-4 {
        stroke: none;
      }

      .cls-4 {
        fill: var(--du-color-primary, #128370);
        stroke: var(--du-color-primary, #128370);
      }
    }
  }
`;

const ExpandIcon: React.FC<IconProps> = ({ active, disabled }) => {
  const activeclass = disabled ? 'disabled' : active ? 'active' : undefined;
  return (
    <StyledExpandSVG
      id='Expand-Icon-SVG'
      xmlns='http://www.w3.org/2000/svg'
      width='40'
      height='40'
      viewBox='0 0 40 40'
      className={activeclass}
      disabled={disabled}
    >
      <g id='Group_17473' data-name='Group 17473'>
        <path id='Margin' className='cls-1' d='M0,0H40V40H0Z' />
        <path
          id='Path_15942'
          data-name='Path 15942'
          className='cls-2'
          d='M28,28H8V8h9.474V9.286H9.286V26.715H26.715V18.526H28ZM13.785,21.31,25.809,9.286H20.865V8H28v7.135H26.715V10.191L14.69,22.215Z'
          transform='translate(2 2)'
        />
      </g>
    </StyledExpandSVG>
  );
};

export default ExpandIcon;
